module.exports = __webpack_public_path__ + "img/pravaahLogo.3e1bf4c6.png";